module.exports = __webpack_public_path__ + "img/1.30b986bd.jpg";